import {WorkRolesList} from "./WorkRolesList";
import {WorkRolesEdit} from "./WorkRolesEdit";
import {WorkRolesCreate} from "./WorkRolesCreate";

export default {
    list: WorkRolesList,
    create: WorkRolesCreate,
    edit: WorkRolesEdit
};
